import { BrowserModule }              from '@angular/platform-browser';
import { NgModule, Inject}            from '@angular/core';
import { FormsModule, 
  ReactiveFormsModule }               from '@angular/forms';
//import { HttpModule }                 from '@angular/http';
import { HttpClientModule }           from '@angular/common/http';
////import { JwtHelper }                  from 'angular2-jwt';
//import { JwtModule }                  from '@auth0/angular-jwt';
import { JwtModule,JwtHelperService }             from "@auth0/angular-jwt"; //https://github.com/auth0/angular2-jwt
import { AppComponent }               from './app.component';
import { LogoComponent }              from './logo/logo.component'; 

import { AuthGuardService }           from './auth/ind/auth-guard.service';
import { AuthService }                from './auth/ind/auth.service';
import { OrgAuthGuardService }        from './auth/org/orgauth-guard.service';
import { OrgAuthService }             from './auth/org/orgauth.service';

import { RouterModule }               from '@angular/router';
import { AppRoutingModule }           from './app-routing.module';
//import * as CryptoJS                  from 'crypto-js';

import { UserService }                from './_services/user.service'; 
import { DialogService }              from './_services/index'; 

import { RegisterComponent }          from './login/register/register.component';
import { ForgotPasswordComponent }    from './login/forgot-password/forgot-password.component';
import { ResetPasswordComponent }     from './login/reset-password/reset-password.component';
import { ActivateComponent }          from './login/activate/activate.component';
import { StartProcessComponent}       from './login/start-process/start-process.component';

import { OrgRegisterComponent }       from './login/orgregister/orgregister.component';
import { OrgForgotPasswordComponent } from './login/orgforgot-password/orgforgot-password.component';
import { OrgResetPasswordComponent }  from './login/org-reset-password/org-reset-password.component';

import { RecaptchaModule, RecaptchaFormsModule }            from 'ng-recaptcha';

import { EqualValidator, 
  EmailValidatorDirective, NoWhitespaceValidatorDirective }           from './_directives/index';
//import { LoginComponent }             from './login/login.component';
import {LOCALE_ID} from '@angular/core';
import { FooterComponent }            from './footer.component';
//import { Angular2PiwikModule } from 'Angular2Piwik';
//import { FlashMessagesModule } from 'angular2-flash-messages';
//import { NgFlashModule } from 'ng-flash';
//import { ToastrModule } from 'ngx-toastr';
import { RouteReuseService } from './_services/RouteReuseService';
import { RouteReuseStrategy } from '@angular/router';

//import { initializeApp }                     from 'firebase/app';
//import { provideFirebaseApp }                from '@angular/fire/app';
//import { provideFirestore, getFirestore }    from '@angular/fire/firestore';
//import { provideAuth, getAuth }              from '@angular/fire/auth';
import { AngularFireModule }                 from '@angular/fire/compat';
import { AngularFirestoreModule }            from '@angular/fire/compat/firestore';
import { AngularFireAuthModule }             from '@angular/fire/compat/auth';


import { environment } from '../environments/environment';
export function requestinitApplicationFunction(request: any){
  {
    if (!request) {
      return sessionStorage.getItem("onreference_ent");
    }
    if (request.url.includes("/adm")) {
      return sessionStorage.getItem("onreference_adm");
    }
    if (request.url.includes("/org")) {
      return sessionStorage.getItem("onreference_org");
    }    
    return sessionStorage.getItem("onreference_ent");
  }
}

export const myComponents = [
  AppComponent,
  RegisterComponent,
  ForgotPasswordComponent,
  ResetPasswordComponent,
  ActivateComponent,
  StartProcessComponent,

  OrgRegisterComponent,
  OrgForgotPasswordComponent,
  OrgResetPasswordComponent,
  EqualValidator,
  EmailValidatorDirective,
  NoWhitespaceValidatorDirective,
  //LoginComponent
  LogoComponent
];

export const myReportComponents = [
  
];

export const myDirectives = [
];


@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    RouterModule,
    AppRoutingModule,    
    ReactiveFormsModule,
    RecaptchaFormsModule,
    RecaptchaModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: requestinitApplicationFunction,
        allowedDomains: ["onreference.com",
          "localhost:4200",
        ],
        disallowedRoutes: [],   
      },
    }),
    
      AngularFireModule.initializeApp(environment.firebaseConfig),  // ← replaces provideFirebaseApp
      AngularFirestoreModule,                                        // ← replaces provideFirestore
      AngularFireAuthModule,                                         // ← replaces provideAuth
    //provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    //provideFirestore(() => getFirestore()),
    //provideAuth(() => getAuth()),

  ],
  declarations: [
    ...myComponents,
    ...myReportComponents,
    FooterComponent,
    LogoComponent
    /*AddReferrersComponent,
    EmailValidatorDirective,
    ForgotPasswordComponent,*/    
  ],
  providers: [  
    //AuthGuardService, 
    AuthService, 
    OrgAuthGuardService, 
    OrgAuthService,     
    //JwtHelper,      
    //JwtHelperService,
    UserService,
    DialogService,
    {provide: RouteReuseStrategy, useClass: RouteReuseService},
    //{provide: LOCALE_ID, useValue: 'fr-FR'}, //{provide: LOCALE_ID, useValue: window['MY_LOCALE']}
  ], 
  bootstrap: [AppComponent]
})
export class AppModule { 
  constructor(){
    //console.log('locale', _locale);
  }
}
